import { reaction } from 'mobx';
import { IReactionDisposer } from 'mobx/lib/internal';
import { ComponentFactory } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-factory';
import { LogicService } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-logic/base/logic-service';
import RegionRenderService from '@src/slide/content-viewer/service/canvas-renderer/entry/base/performance/base-region-render-service';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { RenderPostionType } from '@src/js/constant';

/**
 * 临时元素渲染层
 */
export default class TempElemsRenderService extends RegionRenderService {
    private reaction: IReactionDisposer | null;

    public constructor(props) {
        super(props);
    }

    public init(): void {
        if (!this.reaction) {
            this.reaction = reaction(
                () => (this.getAppServices() as IPcEditorAppServices)
                    .editableServiceLayer?.tempElementManager?.getTempElements(),
                (tempElemModels) => {
                    if (tempElemModels?.length) {
                        this.buildTempElements(tempElemModels);
                    } else {
                        this.clearTempElements();
                    }
                },
            );
        }
    }

    public dispose(): void {
        this.reaction?.();
        this.reaction = null;
    }

    private buildTempElements(tempElemModels: any[] = []) {
        const app = (this.getAppServices() as IPcEditorAppServices);
        const masterLayoutEditService = app.editableServiceLayer?.masterLayoutEditService;
        tempElemModels.reverse().forEach((model) => {
            const insertElement = new ComponentFactory({
                getPageScale: () => this.scale,
                // 这里应该是渲染类型，和区域RegionType有点混淆
                region: RenderPostionType.CANVAS,
                fromScale: 0,
                logicService: new LogicService(),
                getApplication: () => this.application,
                model,
                isTempElement: true,
                infrastructureService: this.getAppServices().getInfrastructureService(),
                uiDataService: this.getAppServices().getUiDataService(),
                mediaManager: this.getAppServices().viewableServiceLayer.mediaManager,
                addonManager: this.getAppServices().viewableServiceLayer.addonManager,
                attachmentManager: (this.getAppServices() as IPcEditorAppServices)
                    .viewableServiceLayer.attachmentManager,
                editingStateManager: this.getAppServices().viewableServiceLayer.editingStateManager,
                formatBrushManager: (this.getAppServices() as IPcEditorAppServices)
                    .editableServiceLayer?.formatBrushManager,
                rightSideBarService: this.getAppServices().viewableServiceLayer.rightSideBarService,
                linkManager: this.getAppServices().viewableServiceLayer.linkManager,
                selectionService: this.getAppServices().viewableServiceLayer.selectionService,
                masterLayoutEditService,
                gifService: this.getAppServices().viewableServiceLayer.gifService,
            }).getWrapper();
            this.updateComponents(insertElement);
        });
    }

    private clearTempElements() {
        this.clearAllComponent();
    }
}
